$ = jQuery;

var $log = function(msg) {
        if (App.debug) {
            if (arguments.length > 1) {
                var to_console = [];
                for (i = 1; i < arguments.length; i++) {
                    to_console[i - 1] = arguments[i][0];
                }
                console.log(msg, to_console);
            }
            else {
                console.log(msg);
            }
        }
    },
    App = {
        debug: true,
        init: function() {

            this.scripts();
            this.mobMenu($(".mobile-header"));

        },
        loaded: function() {},
        scripts: function() {

            var $win = $(window),
                $body = $("body"),
                $mainmenu = $(".menu"),
                // $submenu = $(".menu li.current-menu-item .sub-menu, .menu li.current-menu-ancestor .sub-menu"),
                scrollPos = $win.scrollTop();

            // PAGE LOADING

            var menu_link_a = $('.elementor-widget-wp-widget-nav_menu a'),
                navigation_started = false;

            if (parseInt(sessionStorage.getItem("preloaded"))) {
                sessionStorage.removeItem("preloaded");

                $(".page-header-column").addClass("animated");

                var preloaded_submenu = sessionStorage.getItem("preloaded_submenu");

                if (preloaded_submenu && preloaded_submenu.length) {

                    var submenu = $(preloaded_submenu).find(".sub-menu");

                    if (submenu && sessionStorage.getItem("active_submenu") == preloaded_submenu) {

                        submenu.addClass("animated");
                    }
                    else {
                        setTimeout(function() {
                            submenu.addClass("animated fadeInUp");
                        }, 1200);
                        sessionStorage.setItem("active_submenu", preloaded_submenu);

                    }

                    sessionStorage.removeItem("preloaded_submenu");
                }
            }
            else {
                $("#menu-main-menu .sub-menu").addClass("animated");
            }

            menu_link_a.on("mouseenter", function() {
                var this_background_color = $(this).data("background-color");

                if (!$body.data("background-color")) {
                    $body.data("background-color", $body.css("backgroundColor"));
                }

                if ($body.data("background-color") != this_background_color) {
                    $body.css("backgroundColor", this_background_color);

                }
            }).on("mouseleave", function() {

                if ($body.data("background-color") && !navigation_started) {
                    $body.css("backgroundColor", $body.data("background-color"));
                }

            }).on("click", function(event) {
                event.preventDefault();

                navigation_started = true;

                var link = $(this);

                if ($win.width() > 1023 && !$body.hasClass("home")) {
                    //$('.mobile-header+.elementor-location-header').fadeOut('normal');
                }

                $.get(link.attr("href"), {}, function(response) {

                    var parsed_html = $.parseHTML(response),
                        active_classes = [
                            "current-page-ancestor",
                            "current-menu-ancestor",
                            "current-menu-parent",
                            "current-page-parent",
                            "current_page_parent",
                            "current_page_ancestor"
                        ],
                        search_query = "#menu-main-menu ." + active_classes.join(", #menu-main-menu ."),
                        query = $(search_query, parsed_html),
                        query_current = $(search_query, "body");


                    $body.removeClass('opened');

                    if (query.find(".sub-menu").length) {

                        var preloaded_submenu = "#" + query.eq(0).attr("id");
                        sessionStorage.setItem("preloaded_submenu", preloaded_submenu);

                        if (query.eq(0).attr("id") != query_current.eq(0).attr("id")) {
                            $('#menu-main-menu .sub-menu').addClass("animated fadeOutUp");
                            setTimeout(function() {
                                $('#menu-main-menu .sub-menu').addClass("d-none");
                            }, 600);
                        }

                    }
                    else {
                        $('#menu-main-menu .sub-menu').addClass("animated fadeOutUp");

                        sessionStorage.removeItem("preloaded_submenu");
                        sessionStorage.removeItem("active_submenu");

                        setTimeout(function() {
                            $('#menu-main-menu .sub-menu').addClass("d-none");
                        }, 600);
                    }


                    $('.main-container .elementor-element.elementor-widget').removeClass('fadeInUp').addClass('fadeOutUp');
                    $('.main-container .hero-title .elementor-element.elementor-column').removeClass('fadeInUp').addClass('fadeOutUp');


                    setTimeout(function() {
                        $('.main-container .elementor-element.elementor-widget').removeClass('animated').addClass('d-none');
                        $('.main-container .hero-title .elementor-element.elementor-column').removeClass('animated').addClass('d-none');
                        //$('.page-header .sub-menu').removeClass('animated');
                        $('.main-container').fadeOut('normal', function() {
                            sessionStorage.setItem("preloaded", 1);
                            window.location.href = link.attr("href");
                        });
                    }, 600);
                });

            });

            // ANIMATIONS

            $('.main-container section .elementor-element.elementor-widget').first().addClass('animated');

            if (!$body.hasClass("home") && $('.elementor-section-full_width.page-hero-section').length) {

                var heroTitle = $('.main-container .hero-title .elementor-element.elementor-widget');

                setTimeout(function() {
                    new Waypoint({
                        element: heroTitle,
                        handler: function(direction) {
                            $(this.element).addClass('animated fadeInUp');
                        },
                        offset: '100%'
                    });
                }, 1000);

                var sections = $('.main-container section .elementor-section-full_width').not('.page-hero-section').not('.hero-title'),
                    continuousElements = $('.elementor-element.elementor-widget', sections);

                setTimeout(function() {
                    for (var i = 0; i < continuousElements.length; i++) {
                        var waypoint = new Waypoint({
                            element: continuousElements[i],
                            handler: function(direction) {
                                $(this.element).addClass('animated fadeInUp');
                            },
                            offset: '100%'
                        });
                    }
                }, 1500);
            }

            if (!$body.hasClass("home") && $('.elementor-section-full_width.page-hero-section').length < 1 && !$body.hasClass("single-post")) {

                var sections = $('.main-container section .elementor-section-full_width').not('.page-hero-section').not('.hero-img').not('.hero-title'),
                    //continuousElements = $('.elementor-element.elementor-widget', sections).not('.elementor-widget-theme-post-content'),
                    continuousElements = $('.elementor-element.elementor-widget', sections);

                setTimeout(function() {
                    for (var i = 0; i < continuousElements.length; i++) {
                        var waypoint = new Waypoint({
                            element: continuousElements[i],
                            handler: function(direction) {
                                $(this.element).addClass('animated fadeInUp');
                            },
                            offset: '100%'
                        });
                    }
                }, 1200);

            }

            var page_header = $('.page-header');

            if (page_header.length && $body.hasClass("home")) {

                setTimeout(function() {
                    $('.logo', page_header).addClass('animated');
                }, 200);
                setTimeout(function() {
                    $('.menu', page_header).addClass('animated');
                }, 600);
                setTimeout(function() {
                    $('.elementor-social-icons-wrapper', page_header).addClass('animated');
                }, 1200);

            }

            var hero_img = $('.hero-img'),
                hero_wrapper = $('.home-hero-wrapper');

            if (hero_img.length) {

                hero_img.addClass('animated fadeInUp');
                setTimeout(function() {
                    hero_img.addClass('visible');
                }, 2600);
            }

            if (hero_wrapper.length) {

                setTimeout(function() {
                    hero_wrapper.addClass('visible');
                }, 1200);
                setTimeout(function() {
                    hero_wrapper.addClass('animated');
                }, 1500);
            }

            $win.on('scroll', function() {

                if ($(this).scrollTop() >= 50) {
                    $body.addClass('page-scrolled');
                }
                else {
                    $body.removeClass('page-scrolled');
                }

                scrollPos = $win.scrollTop();

            });

            if ($win.width() > 1023) {

                setTimeout(function() {
                    var $topPos = $mainmenu.offset();
                    //$submenu.css('top', $topPos.top - 20 - scrollPos).addClass('animated fadeInUp');
                }, 1400);

            }

            $win.on('resize', function() {

                if ($win.width() > 1023) {

                    var $topPos = $mainmenu.offset();
                    //$submenu.css('top', $topPos.top - 20 - scrollPos).addClass('animated fadeInUp');

                }

            });

            var main_container = $('.main-container');

            $('.news-list a.read-more, .news-list .news-title a', main_container).on("click", function() {
                $body.removeClass('opened');
                $('.hero-title', main_container).addClass('fadeOutUp animated');
                $(".news-list .news-item", main_container).each(function(index) {
                    var that = this;
                    var t = setTimeout(function() {
                        $(that).addClass('fadeOutUp animated');
                    }, 50 * index);
                });
                setTimeout(function() {
                    main_container.fadeOut('normal', function() {});
                }, 500);
            });

            $('.back-to-news-link a', main_container).on("click", function() {
                $body.removeClass('opened');
                $(".elementor-element.elementor-column.animated", main_container).each(function(index) {
                    var that = this;
                    var t = setTimeout(function() {
                        $(that).removeClass('fadeInUp').addClass('fadeOutUp');
                    }, 50 * index);
                });
            });

            $('body.home .main-container a').on("click", function() {
                $body.removeClass('opened');
                $('.home-hero-wrapper', main_container).addClass('fadeOutUp animated');
                setTimeout(function() {
                    $('.elementor-element.elementor-widget', main_container).removeClass('fadeInUp').addClass('fadeOutUp');
                }, 300);
                setTimeout(function() {
                    $('.elementor-element.elementor-widget', main_container).removeClass('animated').addClass('d-none');
                    main_container.fadeOut('normal', function() {});
                }, 600);
            });




            // ISOTOPE

            var $mediaGrid = $('.media-list')

            $mediaGrid.imagesLoaded(function() {
                $mediaGrid.isotope({
                    // options...
                    percentPosition: false,
                    itemSelector: '.media-item',
                    layoutMode: 'masonry',
                    masonry: {
                        columnWidth: '.media-item'
                    }
                });
            });

            $('.media-filter').on('click', 'span', function() {
                var filterValue = $(this).attr('data-filter');
                $mediaGrid.isotope({ filter: filterValue });
                if (!$(this).hasClass('selected')) {
                    $('.media-filter span').removeClass('selected');
                    $(this).addClass('selected');
                }
            });

            // TO TOP

            $(".back-top").on("click", function() {
                $("html,body").animate({
                    scrollTop: 0
                }, 550);
            });

            // CONTENT LINK

            $(".content-link").click(function(e) {
                if ($(this).attr('data-slug').length && (typeof $(this).data('slug') !== 'undefined')) {
                    e.preventDefault();
                    var id = $(this).attr('data-slug');
                    $('html,body').animate({
                        scrollTop: $('#' + id).offset().top - 50
                    }, 550);
                }
            });

        },

        mobMenu: function(menuWrapper) {

            var $this = menuWrapper,
                $body = $("body");

            /* toggle main menu nav */
            $(".menu-btn", $this).on("click", function() {

                menuWrapper.toggleClass("opened");
                $body.toggleClass("opened");

            });

            $(window).on("keyup", function(event) {

                if ($body.hasClass("opened")) {
                    switch (event.keyCode) {
                        case 27: //esc
                            menuWrapper.removeClass("opened");
                            $body.removeClass("opened");
                            break;
                    }
                }

            });

        },

    };

jQuery(document).ready(function() {
    App.init();
});
